module.exports = __webpack_public_path__ + "img/52-ABITO-ELECTRA-SML-COLORI-LINO-STAMPE-LINO9.03b04e63.jpg";